<template>
    <div class="restricted-block restricted-follow">
        <div class="restricted-contant">
            <div class="contant">
                <span v-html="svg('lock-post')"></span>
                <h2>{{ $t('i18n.followToUnlock') }}</h2>
                <p>{{ $t('i18n.unlockByFollow') }}</p>
                <button :class="buttonClasses" @click="unlock" :disabled="isLoading">
                    <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading"></div>
                    <span v-else>{{ $t('i18n.followTitle') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: {
        unlockType: {
            type: String,
            required: true,
        },
        postId: {
            type: [Number, String],
            required: true,
        },
        buttonClasses: {
            type: String,
            default: "btn btn-primary"
        }
    },
    data() {
        return {
            isLoading: false,
        }
    },
    computed: {
        diamonds: function () {
            return this.type == 'post' ? this.$variables.unlock_post_diamonds : this.$variables.unlock_block_diamonds
        },
    },
    methods: {
        unlock: function () {
            this.isLoading = true
            const url = this.$variables.follow_url

            axios.put(url, { unlock_type: this.unlockType, id: this.postId })
                .then((resp) => {
                    if (resp.data.reload) {
                        self.location.reload();
                    }
                    this.$emit('following', resp.data.success)
                    this.isLoading = false
                })
                .catch(() => {
                    this.isLoading = false
                })
        }
    },
}
</script>
